import { ApiImageClient } from "@/api";
import { authClient } from "@/lib/auth-clients";

async function apiUserGetJWT({
  identifier,
  password,
}: {
  identifier: string;
  password: string;
}) {
  try {
    const result = await ApiImageClient.post(
      "/auth/local",
      {
        identifier,
        password,
      },
      { skipAuth: true },
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetJWT_ERROR", e);
    return e;
  }
}

async function apiUserRegister({
  username,
  email,
  password,
}: {
  username: string;
  email: string;
  password: string;
}) {
  try {
    const result = await ApiImageClient.post(
      "/auth/local/register",
      {
        username,
        email,
        password,
      },
      { skipAuth: true },
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserRegister", e);
    return e;
  }
}

async function apiUserForgetPassword({ email }: { email: string }) {
  try {
    await ApiImageClient.post("/auth/forgetPassword", {
      email,
    });
  } catch (e) {
    console.error("apiUserRegister", e);
    return e;
  }
}

async function apiUserChangePassword({
  password,
  currPassword,
  passwordConfirmation,
}: {
  password: string;
  currPassword: string;
  passwordConfirmation: string;
}) {
  try {
    return await ApiImageClient.post("/auth/changePassword", {
      password,
      currPassword,
      passwordConfirmation,
    }).then(({ jwt }) => jwt);
  } catch (e) {
    console.error("apiUserRegister", e);
    return e;
  }
}

async function apiUserGetMe() {
  try {
    const session = await authClient.getSession();

    if (!session?.data?.user) {
      throw new Error("No user session found");
    }

    const user = session.data.user;

    return {
      id: user.id,
      username: user.name || "",
      email: user.email,
      provider: "",
      confirmed: "true",
      documentId: user.id,
      blocked: "false",
      countryAndRegion: "",
      phoneNumber: "",
    };
  } catch (e) {
    console.error("apiUserGetMe_ERROR", e);
    return e;
  }
}

async function apiUserGoogleAuth({ access_token }: { access_token: string }) {
  try {
    const response = await ApiImageClient.get(
      `/auth/google/callback?access_token=${access_token}`,
      { skipAuth: true },
    );

    if (response.data && response.data.jwt) {
      return response.data.jwt;
    } else {
      throw new Error("No JWT token in response");
    }
  } catch (e: any) {
    console.error("apiUserGoogleAuth_ERROR", e);
    console.error("Error details:", {
      status: e?.response?.status,
      statusText: e?.response?.statusText,
      data: e?.response?.data,
      url: e?.config?.url,
    });
    return e;
  }
}

export {
  apiUserGetJWT,
  apiUserRegister,
  apiUserForgetPassword,
  apiUserChangePassword,
  apiUserGetMe,
  apiUserGoogleAuth,
};
